export const LOGIN = 'auth/LOGIN'
export const LOGOUT = 'auth/LOGOUT'
export const SET_FIREBASE_ACCOUNT = 'auth/SET_FIREBASE_ACCOUNT'
export const SET_USER_ADACCOUNTS = 'auth/SET_USER_ADACCOUNTS'
export const SET_USER_ACCOUNTS = 'auth/SET_USER_ACCOUNTS'
export const TOGGLE_SETUP_MODE = 'auth/TOGGLE_SETUP_MODE'
export const SET_USER_AGENCY = 'auth/SET_USER_AGENCY'
export const SET_ACCOUNT_PIXELS = 'auth/SET_ACCOUNT_PIXELS'
